<template>
    <v-dialog v-model="$store.state.showFeedBackDialog" v-if="$store.state.showFeedBackDialog" width="800" >
      <v-card style="height: 850px;padding: 35px 90px 0 90px">
        <div @click="$store.commit('setShowFeedBackDialog',false)" style="cursor: pointer;position: absolute;right: 27px;top: 27px;width: max-content"><span class="iconfontFamily" style="font-size: 15px;color: rgba(166, 166, 166, 1);">&#xe60d;</span></div>

        <div style="font-size: 24px">欢迎使用吉林一号·共生地球</div>
        <div style="font-size: 16px" class="mt-4">请留下您遇到的问题情况，我们将尽快与您获得沟通</div>
        <v-divider class="mt-3"></v-divider>
        <div style="font-size: 16px" class="mt-8"><span style="color: red">*</span> 问题描述</div>
            <textarea placeholder="请输入问题描述，最多300字" v-model="description" rows="10" cols="70" :style="{ border:isDescriptionError ? '1px solid red' : '1px solid grey'}" @change="onDescriptionChange" style="margin-top: 5px;padding: 5px 5px 25px 5px;width: 620px;height: 200px;outline-color:rgba(25, 118, 210, 1);border-radius: 3px;">
<!--                <template v-slot:append>-->
<!--                  <p style="color: #a6a6a6">/300</p>-->
<!--                </template>-->
            </textarea>
          <div style="font-size: 14px;color: rgba(166, 166, 166, 1);text-align: right;height: 20px;line-height: 20px;float: right">{{description.length}}/300</div>
        <div style="font-size: 16px" class="mt-10">添加图片</div>
          <v-layout row class="mt-2 ml-0" >
            <label for="file">
              <div v-show="imageList.length<5" style="width: 110px;height: 110px;border-radius: 2px;border: 1px dashed rgba(166, 166, 166, 1);position: relative;cursor: pointer;background-color: white" class="mt-3">
                <div style="line-height: 110px;width: max-content;margin: 0 auto;color: rgba(25, 118, 210, 1);font-size: 30px;font-weight: 300">+</div>
              </div>
              <input ref="file" type="file" accept="image/jpg,image/png,image/jpeg"  id="file" style="display: none;" @change="getFileData">
            </label>
            <div  v-for="(item,index) in imageList" :key="index">
              <div style="width: 110px;height: 110px;border-radius: 2px;border: 1px solid rgba(166, 166, 166, 1);position: relative;background-color: white" class="mt-3 ml-3">
                <v-img  :src="item" width="100%" height="100%"></v-img>
                <div @click="deleteImage(index)" style="position: absolute;right: 1px;top: 1px;cursor: pointer;background-color: white;border: 1px solid black;border-radius: 50%;width: 15px;height: 15px;display: flex;align-items: center;justify-content: center;">
                  <div style="scale: 0.5;width: max-content"><span class="iconfontFamily" style="font-size: 15px;color: rgba(0, 0, 0, 1);">&#xe60d;</span></div>
                </div>
              </div>
             </div>
          </v-layout>
        <div style="font-size: 16px" class="mt-8"><span style="color: red">*</span>联系方式</div>
        <input placeholder="请输入您的手机号码" v-model="contact" type="text" oninput="value=value.replace(/[^\d]/g,'')"  style="width: 365px;height: 30px;outline-color:rgba(25, 118, 210, 1);border-radius: 3px;" :style="{ border:isContactError? '1px solid red' : '1px solid grey'}" @change="onContactChange" class="mt-2 pl-2">
        <v-btn
            @click="$store.commit('setShowFeedBackDialog',false)"
          width="100px"
          height="35px"
          color="rgba(245, 245, 245, 1)"
          style="color: black;font-size: 16px;position: absolute;bottom: 68px;right: 200px">
          取消
        </v-btn>
        <v-btn
            @click="commit"
          width="100px"
          height="35px"
          color="rgba(30, 58, 138, 1)"
          style="color: white;font-size: 16px;position: absolute;bottom: 68px;right: 90px">
          提交
        </v-btn>
        <v-snackbar v-model="showChangeAvatarErrorMsg" color="rgba(252, 165, 10, 1)" width="620px" height="30px" absolute top timeout="1000"> {{changeAvatarErrorMsg}}</v-snackbar>
      </v-card>
      <!--loading弹窗-->
      <dialog-loading :dialog-show="showLoadingDialog"></dialog-loading>

    </v-dialog>
</template>

<script>
import DialogLoading from "@/components/loading/DialogLoading";
export default {
  name: "FeedBackDialog",
  components: {DialogLoading},
  data(){
    return {
      description:'',
      contact:'',
      imageFileList:[],
      imageList:[],
      imageUrlList:[],
      isDescriptionError:false,
      isContactError:false,
      showChangeAvatarErrorMsg:false,
      changeAvatarErrorMsg:'文件大小不能超过5M',
      showLoadingDialog:false,
    }
  },
  watch:{
    description(){
      if(this.description.length>300){
        this.description = this.description.slice(0,300)
      }
    },
    contact(){
      if(this.contact.length>11){101
        this.contact = this.contact.slice(0,11)
      }
    }
  },
  methods:{

    onDescriptionChange(){
      if(this.description.length < 1){
        this.isDescriptionError = true
      }else{
        this.isDescriptionError = false
      }
    },
    onContactChange(){
      if(this.contact.length < 1){
        this.isContactError = true
      }else{
        this.isContactError = false
      }
    },
    getFileData() {
      this.changeAvatarErrorMsg = true
      let that = this
      if(this.$refs.file.files.length<1){
        return;
      }
      let file = this.$refs.file.files[0];//图片文件名
      if(file.type !== 'image/png'&&file.type !== 'image/jpg'&&file.type !== 'image/jpeg'){
        this.changeAvatarErrorMsg = '文件必须为以下格式：jpg、jpeg、png'
        this.showChangeAvatarErrorMsg = true
        return;
      }
      if(file.size>1024*1024*5){
        console.log('判断大小')
        this.changeAvatarErrorMsg = '文件大小不能超过5M'
        this.showChangeAvatarErrorMsg = true
        this.$refs.file.value = ''
        setTimeout(function () {
            that.showChangeAvatarErrorMsg = false
        },1000);
        return
    }
      if (!window.FileReader) return; // 看是否支持FileReader
      let reader = new FileReader();
      reader.readAsDataURL(file); // 关键一步，在这里转换的
      reader.onloadend = function () {
        that.imageList.push(this.result)
        that.imageFileList.push(file)
        that.$refs.file.value = ''
      }
    },
    deleteImage(index){
      this.imageFileList.splice(index,1)
      this.imageList.splice(index,1)
    },
    cancel(){
      this.$store.commit('setShowFeedBackDialog',false)
      this.clearContent()
    },
    async commit() {
      this.isContactError = false
      if (this.description.length > 300 || this.description.length < 1 || this.contact.length < 1) {
        if (this.contact.length < 1) {
          this.isContactError = true
        }
        if (this.description.length < 1) {
          this.isDescriptionError = true
        }
        return
      }
      this.showLoadingDialog = true
      for (let i = 0; i < this.imageFileList.length; i++) {
        await this.upLoadImage(this.imageFileList.at(i))
      }
      let formData = new FormData()
      formData.append('feedback', this.description)
      formData.append('phone', this.contact)
      if (this.imageUrlList.length === 1) {
        formData.append('pic1', this.imageUrlList[0])
      } else if (this.imageUrlList.length === 2) {
        formData.append('pic1', this.imageUrlList[0])
        formData.append('pic2', this.imageUrlList[1])
      } else if (this.imageUrlList.length === 3) {
        formData.append('pic1', this.imageUrlList[0])
        formData.append('pic2', this.imageUrlList[1])
        formData.append('pic3', this.imageUrlList[2])
      } else if (this.imageUrlList.length === 4) {
        formData.append('pic1', this.imageUrlList[0])
        formData.append('pic2', this.imageUrlList[1])
        formData.append('pic3', this.imageUrlList[2])
        formData.append('pic4', this.imageUrlList[3])
      } else if (this.imageUrlList.length === 5) {
        formData.append('pic1', this.imageUrlList[0])
        formData.append('pic2', this.imageUrlList[1])
        formData.append('pic3', this.imageUrlList[2])
        formData.append('pic4', this.imageUrlList[3])
        formData.append('pic5', this.imageUrlList[4])
      }
      this.$axios.post('/authorApi/user-feedback/addFeedback', formData).then((resultData) => {
        if (resultData.data.status === 200) {
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = "提交成功"
          this.$store.state.snackbarType = 'success'

          let timer = window.setInterval(() => {
            this.$store.commit('setShowFeedBackDialog', false)
            this.clearContent()
            clearTimeout(timer)
          },  1200)
        }
      })
      this.showLoadingDialog = false
    },
    clearContent(){
      this.description = ''
      this.contact = ''
      this.imageList = []
      this.imageFileList = []
      this.imageUrlList = []
    },
    async upLoadImage(file) {
      let paramData = new FormData();
      paramData.append('multipartFile', file);
      let resultData = await this.$axios.post('/managerApi/upoladFile/uploadPiture', paramData)
      resultData = resultData.data;
      if (resultData.status === 200) {
        this.imageUrlList.push(resultData.data.picture)
      }
    }
  }
}
</script>

<style scoped>

</style>
